// The eye of a field in the card (stage Q, um/2026-10-30/02): seen at once or only under «Показать ещё». The choice is the section's,
// kept on the server (field.update) — every person of the account sees the same card; only the owner changes it.

import { cardEye, type FieldDef } from '@confdeck/core-shared';
import { useSync } from '../sync/react.tsx';
import { IconButton, cx } from '../ui/primitives.tsx';
import s from './settings.module.css';

/** Fields a card shows as properties; the title, long texts and links have their own places. */
export const inCard = (f: FieldDef, titleField?: string) => f.key !== titleField && f.fieldType !== 'longtext' && f.fieldType !== 'relation';

const TITLE = {
  main: 'В карточке видно сразу',
  more: 'В карточке — под «Показать ещё»',
  auto: 'В карточке видно, если заполнено (по умолчанию)',
};

export function CardEye({ field, canEdit }: { field: FieldDef; canEdit: boolean }) {
  const client = useSync();
  const eye = cardEye(field);
  // A click chooses for the section: auto and «под Показать ещё» → seen, seen → hidden. «Как по умолчанию» is in the field's menu.
  const next = eye === 'main' ? 'more' : 'main';
  return (
    <IconButton size="sm" icon={eye === 'more' ? 'eyeOff' : 'eye'} className={cx(s.eye, eye === 'main' && s.eyeOn, eye === 'auto' && s.eyeAuto)} disabled={!canEdit}
      label={`${TITLE[eye]}${canEdit ? '' : ' · меняет владелец'}`}
      onClick={() => client.mutate('field.update', { id: field.id, card: next }, [{ kind: 'field', id: field.id, op: 'patch', data: { card: next } }])} />
  );
}

/** «Как по умолчанию»: the card decides again by what is filled. */
export function resetCardEye(client: ReturnType<typeof useSync>, field: FieldDef) {
  client.mutate('field.update', { id: field.id, card: null }, [{ kind: 'field', id: field.id, op: 'patch', data: { card: null } }]);
}
